import {getSessionKey, ENV_KEY, TOKEN_EXPIRE_TIME, TOKEN_KEY} from './storage'
import moment from 'moment'

const CSC_API_TEST = 'https://connect.test.creditsafe.com/v1'
const CSC_API_STAGE = 'https://connect.stage.creditsafe.com/v1'
const CSC_API_LIVE = 'https://connect.creditsafe.com/v1'

const CSC_ANALYSIS_TEST = 'https://cs-global-s-logging-test.eu.cloudhub.io/api'
const CSC_ANALYSIS_STAGE = 'https://cs-global-s-logging-staged.eu.cloudhub.io/api'
const CSC_ANALYSIS_LIVE = 'https://cs-global-s-logging-live.eu.cloudhub.io/api'

const CSC_TRANSLATIONS_TEST = 'https://cs-monitor-p-test.eu.cloudhub.io/api/v1/'
const CSC_TRANSLATIONS_STAGE = 'https://cs-monitor-p-staged.eu.cloudhub.io/api/v1/'
const CSC_TRANSLATIONS_LIVE = 'https://cs-monitor-p-live.eu.cloudhub.io/api/v1/'

export function fetchUrlBasedOnEnv (env = getSessionKey(ENV_KEY)) {
  if (env === 'live') {
    return CSC_API_LIVE
  } else if (env === 'stage') {
    return CSC_API_STAGE
  } else {
    return CSC_API_TEST
  }
}

export function fetchLogsBasedOnEnv (env = getSessionKey(ENV_KEY)) {
  if (env === 'live') {
    return CSC_ANALYSIS_LIVE
  } else if (env === 'stage') {
    return CSC_ANALYSIS_STAGE
  } else if (env === 'test') {
    return CSC_ANALYSIS_TEST
  }
}
export function getTranslationsDataUrl (env = getSessionKey(ENV_KEY)) {
  if (env === 'live') {
    return CSC_TRANSLATIONS_LIVE
  } else if (env === 'stage') {
    return CSC_TRANSLATIONS_STAGE
  } else if (env === 'test') {
    return CSC_TRANSLATIONS_TEST
  }
}
export function getTokenExpireTime () {
  let currentTime = new Date()
  let nextHourTime = currentTime.setHours(currentTime.getHours() + 1)
  return nextHourTime
}

export function getTokenExpireCountDown () {
  let expireTime = getSessionKey(TOKEN_EXPIRE_TIME)
  if (expireTime) {
    expireTime = parseFloat(expireTime)
    let countDown = (expireTime - (new Date().getTime())) / (1000 * 60)
    if (countDown > 1) {
      // adding 0.5, to make sure that we show the ceil value
      // eg: 59.3333 => 59
      // 59.5666 => 60
      return parseInt(countDown + 0.5, 10)
    } else if (countDown > 0) {
      return 1
    }
    return countDown
  }
  return 60
}

export function isAuthenticated () {
  let tokenFromSession = getSessionKey(TOKEN_KEY)
  if (tokenFromSession) {
    return true
  }
  return false
}

export function copyToClipboard (text, document) {
  let success = false
  if (text && document && typeof document === 'object') {
    // Create a "hidden" input
    let aux = document.createElement('input')
    // Assign it the value of the specified element
    aux.setAttribute('value', text)
    // Append it to the body
    document.body.appendChild(aux)
    // Highlight its content
    aux.select()
    // Copy the highlighted text
    success = document.execCommand('copy')
    // Remove it from the body
    document.body.removeChild(aux)
  }
  return success
}

export function mapUniqueCountries (countries = []) {
  let uniqueCountries = []
  let mappedCountryCodes = []
  countries.map((country) => {
    if (country && mappedCountryCodes.indexOf(country['countryIso2']) === -1) {
      let obj = {}
      obj['name'] = country['countryName']
      obj['value'] = country['countryIso2']
      obj['selected'] = false
      uniqueCountries.push(obj)
      mappedCountryCodes.push(country['countryIso2'])
    }
    return null
  })
  return uniqueCountries
}

export function format (label) {
  return (label.substring(0, 1).toUpperCase() + label.substring(1)).split(/(?=[A-Z])/).join(' ')
}

export const AnalysisFormData = {
  criteriaSets: [
    {key: 'dateStart', name: 'From', required: false, type: 'date'},
    {key: 'dateEnd', name: 'To', required: false, type: 'date'},
    {key: 'userId', name: 'User ID', required: false, type: 'number'},
    {key: 'apiName',
      name: 'API Name',
      required: false,
      allowedValues: [
        {name: 'Monitoring', value: 'cs-monitor-p'},
        {name: 'Search', value: 'cs-ggs-p-search'},
        {name: 'Report', value: 'cs-ggs-p-report'},
        {name: 'Provenir', value: 'cs-provenir-p'},
      ],
      type: 'select'},
    {key: 'includeOnlySuccess', name: 'Include only success', required: false, type: 'boolean'},
  ],
  selectableFields: [
    {key: 'userId', name: 'User ID'},
    {key: 'apiName', name: 'API Name'},
    {key: 'processingTimeMs', name: 'Processing Time'},
    {key: 'ipAddress', name: 'IP Address'},
    {key: 'logType', name: 'Log Type'},
    {key: 'message', name: 'Message body json'},
  ],
  initialParams: {
    productId: 1,
    dateStart: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    dateEnd: moment().format('YYYY-MM-DD'),
    userId: '',
    apiName: '',
    includeOnlySuccess: false,
  },
  maxPageSize: 1000,
}

export function formatDate (date, key) {
  if (key === 'dateStart') {
    return moment.utc(date).startOf('day').format()
  } else {
    return moment.utc(date).endOf('day').format()
  }
}
export const TranslationsFormData = {
  supportedLanguages: [
    {code: 'DE', language: 'Deutsch', flagCode: 'DE', checked: ''},
    {code: 'EN', language: 'English', flagCode: 'EN', checked: ''},
    {code: 'FR', language: 'Français', flagCode: 'FR', checked: ''},
    {code: 'IT', language: 'Italiano', flagCode: 'IT', checked: ''},
    {code: 'NL', language: 'Nederlands(NL)', flagCode: 'NL', checked: ''},
    {code: 'BE', language: 'Nederlands(BE)', flagCode: 'BE', checked: ''},
    {code: 'NO', language: 'Norsk, Bokmål', flagCode: 'NO', checked: ''},
    {code: 'JA', language: '日本語', flagCode: 'JP'}],
  supportedResourceSets: [
    {key: '', name: 'All'},
    {key: 'riskTrackerService', name: 'Monitoring Button'},
  ],
  initialParams: {
    locale: 'EN',
    searchText: '',
    resourceSet: '',
  },
  columns: [
    {key: 'edit', name: ''},
    {key: 'resourceId', name: 'Value (EN)'},
    {key: 'locale', name: 'Locale'},
    {key: 'trans', name: 'Translation'},
    {key: 'createdDate', name: 'Created Date'},
    {key: 'modifiedDate', name: 'Updated Date'},
  ],
}
export const getDefaultLocale = (languages) => (languages.includes('GB') || languages.includes('EN'))
  ? 'EN' : languages[0]



// WEBPACK FOOTER //
// ./src/util/helpers.js